import { useMutation } from "@apollo/client";
import { saveAs } from "file-saver";
import { errorNotification, successNotification } from "components/request-result";
import { WORK_SESSIONS_EXPORT_EXCEL } from "graphql/mutation/staff-management-gql";


const getFileNameFromUrl = (url) => url.split(/[?#]/)[ 0 ].split("/").pop();

const useStaffWorkSessionsExportExcel = () => {
    const [ runWorkSessionsExportExcel, { loading } ] = useMutation(
        WORK_SESSIONS_EXPORT_EXCEL,
        {
            onCompleted(data) {
                const payload = data?.workSessionsExportExcel;

                if (payload)
                {
                    successNotification({
                        title: payload.label,
                        description: payload.message,
                    });
                }

                if (payload?.file)
                {
                    saveAs(payload.file, getFileNameFromUrl(payload.file));
                }
            },
            onError: errorNotification,
        }
    );

    return {
        exportWorkSessionsExcel: (eventID) => runWorkSessionsExportExcel({
            variables: {
                eeID: String(eventID),
            },
        }),
        loadingWorkSessionsExportExcel: loading,
    };
};

export default useStaffWorkSessionsExportExcel;
